// extracted by mini-css-extract-plugin
module.exports = {"menuList":"App_menuList__1AuTs","link":"App_link__19dol","activeAbout":"App_activeAbout__gCbhn","activeTodo":"App_activeTodo__erKyJ"};